import { Controller } from "stimulus";

export default class extends Controller {
  fetchForTarget(url, target) {
    return fetch(url,
      {
        cache: "reload"
      }
    )
      .then(response => this.handleFetchErrors(response, target))
      .then(response => response.text())
      .then(html => {
        target.innerHTML = html;
      });
  }

  handleFetchErrors(response, target) {
    if (!response.ok) {
      target.innerHTML = "<p>There was a problem loading this data.</p>";
      throw Error(response.statusText);
    } else {
      return response;
    }
  }
}